import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { fetchPageContent } from '../../../../entities/PageContent'
import { useAppDispatch } from '../useAppDispatch/useAppDispatch'

export const usePageContent = () => {
    const dispatch = useAppDispatch()
    const { i18n } = useTranslation()

    useEffect(() => {
        dispatch(fetchPageContent(i18n.language))
    }, [dispatch, i18n.language])
}
